import React from "react";
import { Helmet } from "react-helmet";

function SSoft_Solution_EAM_Seo() {
  return (
    <Helmet>
      <title>
        Hexagon EAM Indonesia | Enterprise Asset Management by PT Supersoft
        Sistemindo
      </title>
      <meta
        name="description"
        content="Hexagon EAM adalah solusi Enterprise Asset Management (EAM) yang membantu perusahaan meningkatkan efisiensi dan umur aset. PT Supersoft Sistemindo menyediakan lisensi dan implementasi resmi di Indonesia."
      />
      <meta
        name="keywords"
        content="Hexagon EAM Indonesia, Enterprise Asset Management, asset maintenance system, PT Supersoft Sistemindo, predictive maintenance, IoT asset management"
      />
      <link
        rel="canonical"
        href="https://ptsupersoft.com/solutions/enterprise-asset-management"
      />

      {/* ==== Open Graph ==== */}
      <meta property="og:type" content="website" />
      <meta
        property="og:url"
        content="https://ptsupersoft.com/solutions/enterprise-asset-management"
      />
      <meta
        property="og:title"
        content="Hexagon EAM Indonesia | Enterprise Asset Management Solution"
      />
      <meta
        property="og:description"
        content="Optimalkan kinerja aset Anda dengan Hexagon EAM. Supersoft menyediakan lisensi dan implementasi di Indonesia untuk solusi manajemen aset enterprise."
      />
      <meta
        property="og:image"
        content="https://bzpublishassets.blob.core.windows.net/media/assets/eam_banner.png"
      />

      {/* ==== AI Search Optimization ==== */}
      <meta
        name="ai-keywords"
        content="Hexagon EAM Indonesia, enterprise asset management software, predictive maintenance Indonesia, PT Supersoft Sistemindo, asset lifecycle management"
      />
      <meta
        name="ai-summary"
        content="Hexagon EAM meningkatkan efisiensi, mengurangi downtime, dan memperpanjang umur aset melalui analitik dan integrasi IoT. Partner resmi: PT Supersoft Sistemindo."
      />

      {/* ==== FAQ Schema ==== */}
      <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "Apa itu Hexagon EAM?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Hexagon EAM adalah sistem manajemen aset tingkat enterprise untuk memaksimalkan umur aset dan mengurangi biaya perawatan. PT Supersoft Sistemindo adalah partner resmi implementasi di Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "What is Hexagon EAM?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Hexagon EAM helps enterprises manage asset lifecycle, improve reliability, and reduce maintenance costs. PT Supersoft Sistemindo provides licensing and implementation services in Indonesia."
            }
          },
          {
            "@type": "Question",
            "name": "Apa keunggulan Hexagon EAM?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Keunggulannya termasuk integrasi IoT, prediktif maintenance, analisis berbasis AI, dan visibilitas penuh terhadap kondisi aset secara real-time."
            }
          }
        ]
      }
      `}</script>
    </Helmet>
  );
}

export default SSoft_Solution_EAM_Seo;
